import { createFilterPredicate } from './filter.js';
import { createPropertyFilterPredicate } from './property-filter.js';
import { createComparator } from './sort.js';
import { createPageProps } from './pagination.js';
import { composeFilters } from './compose-filters.js';
export function processItems(items, _a, _b) {
    var filteringText = _a.filteringText, sortingState = _a.sortingState, currentPageIndex = _a.currentPageIndex, propertyFilteringQuery = _a.propertyFilteringQuery;
    var filtering = _b.filtering, sorting = _b.sorting, pagination = _b.pagination, propertyFiltering = _b.propertyFiltering;
    var filterPredicate = composeFilters(createPropertyFilterPredicate(propertyFiltering, propertyFilteringQuery), createFilterPredicate(filtering, filteringText));
    if (filterPredicate) {
        items = items.filter(filterPredicate);
    }
    var filteredItemsCount = filterPredicate ? items.length : undefined;
    var comparator = createComparator(sorting, sortingState);
    if (comparator) {
        items = items.slice().sort(comparator);
    }
    var allPageItems = items;
    var pageProps = createPageProps(pagination, currentPageIndex, items);
    if (pageProps) {
        items = items.slice((pageProps.pageIndex - 1) * pageProps.pageSize, pageProps.pageIndex * pageProps.pageSize);
    }
    return {
        items: items,
        allPageItems: allPageItems,
        filteredItemsCount: filteredItemsCount,
        pagesCount: pageProps === null || pageProps === void 0 ? void 0 : pageProps.pagesCount,
        actualPageIndex: pageProps === null || pageProps === void 0 ? void 0 : pageProps.pageIndex,
    };
}
export var getTrackableValue = function (trackBy, item) {
    if (!trackBy) {
        return item;
    }
    if (typeof trackBy === 'function') {
        return trackBy(item);
    }
    return item[trackBy];
};
export var processSelectedItems = function (items, selectedItems, trackBy) {
    var selectedSet = new Set();
    selectedItems.forEach(function (item) { return selectedSet.add(getTrackableValue(trackBy, item)); });
    return items.filter(function (item) { return selectedSet.has(getTrackableValue(trackBy, item)); });
};
export var itemsAreEqual = function (items1, items2, trackBy) {
    if (items1.length !== items2.length) {
        return false;
    }
    var set1 = new Set();
    items1.forEach(function (item) { return set1.add(getTrackableValue(trackBy, item)); });
    return items2.every(function (item) { return set1.has(getTrackableValue(trackBy, item)); });
};
